import { useState, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import useFetch from '../../hooks/useFetch';
import useIsMobileView from "../../hooks/useIsMobileView";
import { Main, MainContent, Section, LoadingIcon } from '@prosolve/common-components-ui'
import SoefiaBackground from '../../images/soefia-assessment/bkg-metal.png';
import moment from 'moment';
import pdChallengeData from '../PdChallengeData.json'
// import TeamMetricsDisplay from './TeamMetricsDisplay';
import GroupTeamMetricsDisplay from './GroupTeamMetricsDisplay';
import whatIfCodeMap from './WhatIfsCodeMap.json'
import ProsolveLogo from '../../images/prosolve-logo-new.png';

const Title = styled.div`
  color: #c7ffff;
  font-size: 48px;
  text-align: center;
  margin-bottom: 40px;
  font-family: "PassionOne-Regular", "Open Sans", sans-serif;
`

const calcScoreDistribution = (strand = {}) => {
  const {
    // skill_name,
    // strand_name,
    ipStrands = []
  } = strand;

  // console.log(strand)

  // console.log(ipStrands)

  const scoreMap = { '1': 0, '2': 0, '3': 0, '4': 0}

  ipStrands.forEach(({ score_distribution = {}, instances = [] }) => {
    Object.keys(score_distribution).forEach(key => {
      const val = score_distribution[key]
      scoreMap[key] += val;
    });
  });

            // if (skill_name === 'Critical_Thinking' && strand_name === 'Analysis') {
            //   console.log(scoreMap)
            // }
            
  const weightMap = { '1': 25, '2': 50, '3': 75, '4': 100 }

  let total = 0;
  let totalWeighted = 0;
  Object.keys(scoreMap).forEach(key => {
    const val = scoreMap[key]
    total += val;

    const weightedVal = val * weightMap[key]

    totalWeighted += weightedVal;
  });

  const finalPercentage = ( totalWeighted / (total * 100) ) * 100;

  return finalPercentage;
}


export default () => {
  const urlParams = new URLSearchParams(window.location.search);
  const assessmentAnswerId = urlParams.get('assessmentAnswerId');
  const dateTime = urlParams.get('dateTime');
  const teamNameUrlParam = urlParams.get('teamName');

  const [answerData, setAnswerData] = useState([])
  const [loading, setLoading] = useState(true)

  const isMobileView = useIsMobileView();

  const whatIfsMap = (code) => {
    const formattedCode = Boolean(code) && code.replace(/\s+/g, '').toUpperCase().trim()
    if (Boolean(formattedCode) && whatIfCodeMap[formattedCode]) {
      return whatIfCodeMap[formattedCode];
    } else {
     if (Boolean(formattedCode) && formattedCode.indexOf('PS') === 0) {
      const psNum = Number(formattedCode.substring(2))
      return ( psNum > 0 && psNum <= 30 ) ? psNum : 1;
     } else {
      // always return a value of 1 if unable to find a valid code in the map and not of ps type
      return 1;
     }
    }
  }

  const fetch = useFetch();

  const getAssessmentAnswerData = async () => {
    try {
      setLoading(true)

      const today = moment(dateTime || undefined).utc().format() // moment().format('YYYY-MM-DD') // '2025-11-13'

      const assessmentNames = pdChallengeData.map(({ assessmentName}) => assessmentName).join(',')

      const response = await fetch(`assessment/pdExperienceLeaderboard?date=${today}&assessmentNames=${assessmentNames}`, { method: 'GET' })
      const jsonData = await response.json();

      const data = jsonData || {};

      if (data.error) {
        throw data.error
      }

      setAnswerData(data)
      setLoading(false)
    } catch (e) {
      console.log(e)
      setAnswerData({})
      setLoading(false)
    }
  }

  useEffect(() => {
    getAssessmentAnswerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentAnswerId])

  // TODO: this is where i need to sort and combines ton of data into groups per teamName/color and then for each combo show their
  // TeamMetricsDisplay object

  // I also need to get the ChatGpt Eleanor code to get What if numbers and display here
  // const processedAnswerData = useMemo(() => {
  //   const processedData = []
  //   answerData.forEach(obj => {
  //     processedData.push(obj)
  //   });
  //   return processedData;
  // }, [answerData])

  const processedAnswerData = useMemo(() => {
    const processedDataMap = {}

    answerData.forEach(obj => {
      const {
        soefiaMetrics = {}
      } = obj;

      const {
        analysis_result: {
          individual_performance = [],
          group_performance: gpStrands = []
        } = {}
      } = soefiaMetrics

      individual_performance.forEach(({ strands = [] }) => {
        strands.forEach(strand => {
          const {
            skill_name: ipSkillName,
            strand_name: ipStrandName
          } = strand;

          const matchingMainStrand = gpStrands.find(({ skill_name, strand_name }) => skill_name === ipSkillName && strand_name === ipStrandName)

          if (matchingMainStrand) {
            if (!matchingMainStrand.ipStrands) {
              matchingMainStrand.ipStrands = []
            }
            matchingMainStrand.ipStrands.push(strand)
          }
        });
      });
    })

    answerData.forEach(obj => {

      const {
        teamColor = '',
        teamName = '',
        assessmentName = '',
        answers = {},
        soefiaMetrics = {}
      } = obj;

      // Need to update this special assessment name setup when we finalize
      let whatIfsNum;
      if (assessmentName === 'AAAAChatGptCode') {
        const answerOne = answers[1] || {}
        const { answerText = '' } = answerOne;
        whatIfsNum = whatIfsMap(answerText)
      }

      const {
          analysis_result: {
          // individual_performance = [],
          group_performance: gpStrands = []
        } = {}
      } = soefiaMetrics

      // const ipOne = individual_performance[0] || {}

      // const { strands = [] } = ipOne;


      // group_performance strands do not have a score_percentage value which is needed to display, so normalize this data
      // with the individual_performance data by mapping the 'weighted_average_percentage' into the score_percentage value
      // note: we are ignoring the simple_average_percentage for now but writing it down in case we want to use it at a later date
      const strands = gpStrands.map(gpStrand => ({ ...gpStrand, score_percentage: gpStrand.weighted_average_percentage }));

      const validStrands = strands.filter(({ score_percentage }) => score_percentage > 0)

      // console.log(assessmentName)

      if (teamName && teamColor && (validStrands.length > 0 || Boolean(whatIfsNum))) {
        const key = `${teamName}${teamColor}`

        // console.log(key)

        if (!processedDataMap[key]) {
          processedDataMap[key] = {
            teamName,
            teamColor,
            strands: validStrands
          }
        } else {

          const currStrands = processedDataMap[key].strands;

          validStrands.forEach(validStrand => {
            const { skill_name = '', strand_name = '', ipStrands: addIpStrands = [] /* score_percentage */ } = validStrand;

            // if (skill_name === 'Critical_Thinking' && strand_name === 'Analysis') {
            //   console.log(validStrand)
            // }

            // currStrands.ipStrands.push(...ipStrands);

            const score_percentage = calcScoreDistribution(validStrand)

            // if (skill_name === 'Critical_Thinking' && strand_name === 'Analysis') {
            //   console.log(score_percentage)
            // }
            

            const matchingCurrentStrand = currStrands.find(({ skill_name: currSkillName, strand_name: currStrandName }) => currSkillName === skill_name && currStrandName === strand_name)
            if (matchingCurrentStrand) {
              const { add_score_percentages, ipStrands = [] } = matchingCurrentStrand;
              if (add_score_percentages) {
                add_score_percentages.push(score_percentage)
              } else {
                matchingCurrentStrand.add_score_percentages = [score_percentage]
              }
              ipStrands.push(...addIpStrands);
            } else {
              currStrands.push(validStrand)
            }
          });
        }

        if (Boolean(whatIfsNum)) {
          processedDataMap[key].whatIfsNum = whatIfsNum;
        }

        // // Add in all individual strands
        // const mainStrands = processedDataMap[key].strands;

        // individual_performance.forEach(({ strands = []}) => {
        //   strands.forEach(strand => {
        //     const {
        //       skill_name: ipSkillName,
        //       strand_name: ipStrandName
        //     } = strand;

        //     const matchingMainStrand = mainStrands.find(({ skill_name, strand_name }) => skill_name === ipSkillName && strand_name === ipStrandName)

        //     if (matchingMainStrand) {
        //       if (!matchingMainStrand.ipStrands) {
        //         matchingMainStrand.ipStrands = []
        //       }
        //       matchingMainStrand.ipStrands.push(strand)
        //     }
        //   });
        // });
      }
    });

    const processedAnswerDataArray = Object.values(processedDataMap);

    // Next step is to average the base score_percentage with all of the add_score_percentages values
    return processedAnswerDataArray.map((dataObj) => {
      const { strands = [], whatIfsNum } = dataObj;

     //  console.log(dataObj)

      const processedStrands = strands.map((strandObj) => {
        // const { /* score_percentage, */ add_score_percentages = [] } = strandObj;

        const score_percentage = calcScoreDistribution(strandObj)

        // console.log(score_percentage)

        const allValues = [score_percentage] // , ...add_score_percentages];

            // if (skill_name === 'Critical_Thinking' && strand_name === 'Analysis') {
            //  console.log(allValues)
            // }


        const average = allValues.reduce((sum, n) => sum + n, 0) / allValues.length;

        const finalStrand = {
          ...strandObj,
          score_percentage: average
        }
        if (finalStrand.add_score_percentages) {
          delete finalStrand.add_score_percentages;
        }

        return finalStrand
      })

      const totalScore = processedStrands.reduce((sum, item) => {
        return sum + (item.score_percentage ?? 0);
      }, 0);

      const average = processedStrands.length > 0 ? totalScore / processedStrands.length : 0;

      const finalScore = average * (whatIfsNum || 1)

      return {
        ...dataObj,
        strands: processedStrands,
        finalScore,
        humanScore: average
      };
    })
    .sort((a, b) => b.finalScore - a.finalScore)
  }, [answerData])

  const hasPendingSoefiaCalculations = useMemo(() => {
    if (teamNameUrlParam) {
      const filteredAnswerData = answerData.filter(({ teamName = ''}) => {
        return teamName.toLowerCase() === teamNameUrlParam.toLowerCase()
      })

      let hasSoefiaMetricsGenerationInProgress = false;
      filteredAnswerData.forEach(({ soefiaMetricsGenerationInProgress }) => {
        if (soefiaMetricsGenerationInProgress) {
          hasSoefiaMetricsGenerationInProgress = true
        }
      });

      return hasSoefiaMetricsGenerationInProgress;
    } else {
      return false;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answerData])

  // If we have pending soefia calcuations (which only is true if in a team via and has the pending flag set to true), then we poll every 3 seconds for data
  const pollId = useRef();
  const pollCount = useRef(0)
  const maxPollCalls = 20;
  useEffect(() => {
    const stopPolling = () => {
      if (pollId.current) {
        clearInterval(pollId.current)
        pollId.current = undefined;
        pollCount.current = 0
      }
    }

    if (hasPendingSoefiaCalculations) {
      pollId.current = setInterval(() => {
        pollCount.current++;
        getAssessmentAnswerData()
        if (pollCount.current >= maxPollCalls) {
          stopPolling()
        }
      }, 3000)
    } else {
      stopPolling()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPendingSoefiaCalculations])

  return (
    <Main $isMobileView={isMobileView} style={{
      color: '#c7ffff',
      backgroundImage: `url(${SoefiaBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      // fontFamily: '"Inter_24pt-Bold", "Open Sans", sans-serif'
    }}>
      <div style={{ position: 'absolute', top: '20px', left: '0px', display: 'flex', width: '100%', justifyContent: 'center' }}>
        <img src={ProsolveLogo} style={{ height: '40px', marginLeft: '0px', marginRight: '0px' }} alt="prosolveLogo"/>
      </div>
      <MainContent $isMobileView={isMobileView} style={{ maxWidth: '1200px' }}>
        <Section style={{ background: 'none' }}>
          { !Boolean(teamNameUrlParam) && <Title>{''}</Title> }
          {
            (loading || hasPendingSoefiaCalculations )
              ?
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                <LoadingIcon />
              </div>
              :
              processedAnswerData.length > 0
              ?
              <div style={{ display: 'flex', flexDirection: 'column', border: Boolean(teamNameUrlParam) ? 'none' : '1px solid #c4c4c4', borderRadius: '10px' /* gap: '40px' */ }}>
                {/* {
                  processedAnswerData.map((answerData) => {
                    const { 
                      _id,
                      teamColor = '',
                      teamName = '',
                      soefiaMetrics = {} 
                    } = answerData;
                    return (
                      <GroupTeamMetricsDisplay 
                        key={_id || `${teamName}${teamColor}`}
                        teamColor={teamColor}
                        teamName={teamName}
                        soefiaMetrics={soefiaMetrics}
                      />
                    )
                  })
                } */}
                {
                  processedAnswerData
                  .filter(({ teamName = ''}) => {
                    if (teamNameUrlParam) {
                      return teamName.toLowerCase() === teamNameUrlParam.toLowerCase();
                    } else {
                      return true;
                    }
                  })
                  .map((answerData, index) => {
                    const {
                      teamColor = '',
                      teamName = '',
                      strands = {},
                      whatIfsNum,
                      finalScore,
                      humanScore
                    } = answerData;
                    return (
                      <GroupTeamMetricsDisplay 
                        key={`${teamName}${teamColor}`}
                        teamColor={teamColor}
                        teamName={teamName}
                        strands={strands}
                        whatIfsNum={whatIfsNum}
                        finalScore={finalScore}
                        humanScore={humanScore}
                        isSingleView={Boolean(teamNameUrlParam)}
                        rank={index + 1}
                        isLast={index === processedAnswerData.length - 1}
                      />
                    )
                  })
                }
              </div>
              :
              <div>
                {'No active leaderboard data found'}
              </div>
          }
        </Section>
      </MainContent>
    </Main>
  )
}